// Documenti legali pubblicati su Iubenda (sito 4591299, policy 97685173).
//
// Unica fonte dei link: banner cookie, footer, pagina Account e Privacy Policy.
// La Privacy Policy approvata rimanda alla cookie policy «nel footer del sito e
// al seguente link». Oggi Iubenda pubblica questi documenti solo in tedesco: le
// versioni IT/EN si aggiungono dall'account Iubenda, non da qui. La Privacy
// Policy invece è una pagina del sito (/:locale/privacy), non un link Iubenda.
const IUBENDA_POLICY_ID = "97685173";

export const COOKIE_POLICY_URL = `https://www.iubenda.com/privacy-policy/${IUBENDA_POLICY_ID}/cookie-policy`;
export const TERMS_URL = `https://www.iubenda.com/terms-and-conditions/${IUBENDA_POLICY_ID}`;
